/**
 *
 * @param name searchName
 * @param url 链接url
 * @param options
 * @returns
 */
export const getQuery = (
  name,
  url = "",
  options = { stringify: false, params: {} }
) => {
  const i = url.indexOf("?");
  const searchString = i > -1 ? url.slice(i + 1) : window.location.search;
  const params = new URLSearchParams(searchString);
  // patch for params
  Object.entries(options.params).forEach(([k, v]) => {
    params.set(k, v);
  });

  if (name) {
    return params.get(name);
  } else {
    if (options.stringify) {
      return params.toString();
    }

    const _params = Object.create(null);
    for (const [k, v] of params.entries()) {
      _params[k] = v;
    }

    return _params;
  }
};

const getCallbackFn = (function () {
  let index = 1;
  return function (cb, params, isStay) {
    const isIframe = getQuery("isIframe");
    const fnName = "_clientCallBack" + index++;
    const w = isIframe ? window.top : window;
    w[fnName] = function (result) {
      cb(result);
      !isStay && delete w[fnName];
    };
    const cbFn = params && params.callbackName;
    if (cbFn) {
      const cbName = "_clientCallBack" + index++;
      w[cbName] = function (result) {
        cbFn(result);
      };
      params.callbackName = cbName;
    }
    return "window." + fnName;
  };
})();

export const isWPSClient = function () {
  const { searchParams } = new URL(location.href);
  // 当bypass_wps_client为'true'时,绕过wps客户端的调用
  const bypass = searchParams.get("bypass_wps_client") == "true";
  if (bypass) {
    return false;
  }
  if (typeof cefQuery != "undefined") {
    return true;
  } else {
    return false;
  }
};

/**
 *
 * @string fnStr
 * @array argObjs [{key:xxx,value:xxx}] or {key1: value1, key2: value2}
 * @fn cb
 */
export const callWPSClientAPI = function (fnStr, argObjs, cb, isStay) {
  if (!isWPSClient()) {
    console.warn("Current is not wps client, call this method do not work.");
    return (
      cb &&
      cb(new Error("Current is not wps client, call this method do not work."))
    );
  }

  argObjs = argObjs || [];
  var argValueArr = [],
    params = {},
    argObj,
    key,
    value;

  if (Array.isArray(argObjs)) {
    for (let i = 0; i < argObjs.length; i++) {
      argObj = argObjs[i];
      key = argObj.key;
      value = argObj.value;

      argValueArr.push(value);
      params[key] = value;
    }
    // argObjs is Object
  } else {
    for (key in argObjs) {
      value = argObjs[key];
      argValueArr.push(value);
      params[key] = value;
    }
  }

  try {
    params.method = fnStr;
    if (cb) {
      const callback = getCallbackFn(cb, params.params, isStay);
      params.callback = callback;
      if (params.params) {
        params.params.callbackName = callback;
      }
    }
    const cefParams = {
      request: "jsAsynCall('" + JSON.stringify(params) + "')",
      persistent: false,
      onSuccess: function (response) {
        /* eslint-disable */
        cb && cb(response);
      },
      onFailure: function (error_code, error_message) {
        /* eslint-disable */
        console.log(error_code, error_message);
      },
    };
    /* eslint-disable */
    console.log("params:", params);
    /* eslint-disable */
    console.log("cefQuery: ", cefParams);
    window.cefQuery(cefParams);
  } catch (e) {
    let clientErr;
    try {
      clientErr = JSON.stringify(e);
    } catch (err) {
      clientErr = e;
    }
    /* eslint-disable */
    console.error("call client api fail:", clientErr);
  }
};

/**
 * 获取app信息
 * @param {*} cb
 * @returns
 */
export const getAppInfo = (cb) => {
  return new Promise((resolve, reject) => {
    const tid = setTimeout(() => {
      reject(new Error("call wps api timeout!"));
    }, 1000);
    callWPSClientAPI(
      "common.wpsoffice.getAppInfo",
      {
        params: {},
      },
      (res) => {
        if (res instanceof Error) {
          reject(res);
          window.clearTimeout(tid);
        } else if (res && typeof res === "string") {
          let appInfo = {};
          try {
            appInfo = JSON.parse(res);
          } catch (error) {
            appInfo = {};
          }
          console.log("AppInfo: ", appInfo);
          if (cb) {
            cb(res);
          }
          resolve(appInfo);
          window.clearTimeout(tid);
        }
      }
    );
  });
};
